import {NAVLINK_VERSIONS} from '../appBarTracking';
import useFofNavbarPhase2a from './useFofNavbarPhase2a';
import useFofNavbarPhase2b from './useFofNavbarPhase2b';

/**
 * Navbar surfaces whose version tag a phase 2 experiment may switch. `unaffected` covers every
 * surface no phase 2 experiment changes (Notifications, User, the AppBar profile, the menu-page
 * mobile cart button); they keep the phase 1 tag in every arm.
 */
export type NavbarSurface = 'unaffected' | 'draftCart' | 'orders';

/**
 * Returns the navbar "version" tag for a surface. Each surface a phase 2 experiment changes is
 * tagged by THAT experiment's own arm — p2a and p2b are independent, so one user can be in both
 * arms at once — and every other surface keeps the phase 1 tag. `draftCart` follows p2a's arm gate,
 * so guests and masquerading users, who are held to control, keep the phase 1 tag. `orders` follows
 * p2b's arm gate. Reading the arm never exposes the user.
 */
const useNavbarVersion = (surface: NavbarSurface = 'unaffected') => {
  const {isFofNavbarPhase2aTreatment} = useFofNavbarPhase2a();
  const {isFofNavbarPhase2bTreatment} = useFofNavbarPhase2b();

  if (surface === 'draftCart' && isFofNavbarPhase2aTreatment) return NAVLINK_VERSIONS.FOF_PHASE_2A;
  if (surface === 'orders' && isFofNavbarPhase2bTreatment) return NAVLINK_VERSIONS.FOF_PHASE_2B;

  return NAVLINK_VERSIONS.FOF_PHASE_1;
};

export default useNavbarVersion;
